import Icon from "../../../components/atoms/Icon";
import React from "react";

const NoInternetLogo = () => {
    return (<div className={`flex flex-col justify-center items-center h-[87%]`} dir={"rtl"}>
        <Icon iconName={"internet-empty-logo"}/>
        <p className={"text-dark-blue-200"}>عدم اتصال به اینترنت.</p>
        <p className={"text-dark-blue-200 text-12 font-normal mt-2"}>لطفا اتصال به اینترنت خود را بررسی کنید.</p>

    </div>);
}
export default NoInternetLogo